/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

export const ProductPage = () => {
  return <div css={css`min-height: 500px;`}>Placeholder Product Page</div>;
};
